import { useModuleNavigation } from "@/common/hooks/use-navigation";
import { DashboardSection } from "@/components/dashboard/dashboard-section";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { NoPermissionCard } from "@/components/no-permission-card/no-permission-card";
import { ChartLineIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ApplicationMetric } from "./_components/application-metric";
import { GroupMetric } from "./_components/group-metric";
import { UserMetric } from "./_components/user-metric";

export function RamDashboardView() {
  const { t } = useTranslation(["ram", "common"]);
  const ramConfig = useModuleNavigation("ram");
  const pageTitle = "RAM " + t("common:Dashboard");
  const pageSubtitle = t("ram:DashboardDescription");

  if (!ramConfig) {
    return <NoPermissionCard />;
  }

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Default} title={pageTitle} subTitle={pageSubtitle}>
      <DashboardSection title={t("common:Statistics")} icon={ChartLineIcon}>
        <ApplicationMetric />
        <GroupMetric />
        <UserMetric />
      </DashboardSection>
    </CenteredLayout>
  );
}
